module.exports = __webpack_public_path__ + "img/23_110.f6594ba5.png";